import React from "react";
import { getArbokOriginFullUrl } from "../../../../../utils/media.utils";
// @ts-ignore
import { Player } from 'video-react';
const Video = (props) => {
    const { message } = props;
    return (React.createElement(Player, { style: { width: "100px" } },
        React.createElement("source", { src: getArbokOriginFullUrl(message.uri) })));
};
export default Video;
